import { Download } from '@mui/icons-material';
import { Box, Grid, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';
import { useSnackbar } from 'notistack';
import { FC, useState } from 'react';
import { ManyImagesUpload, Button as SMButton } from '../../../../components';
import { createCompactionLetter } from '../../../../fetch';

interface ILotInfoImagesProps {
  jobId: string;
  image?: string;
  photoOwnerType: string;
  imageTitle: string;
  refetchLetter?: () => void;
}

export const LotInfoImages: FC<ILotInfoImagesProps> = ({
  jobId,
  image,
  photoOwnerType,
  imageTitle,
  refetchLetter
}) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [isUploading, setUploading] = useState(false);

  const handleDownload = image => {
    const blob = new Blob([image], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'document.pdf';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  return (
    <>
      <Box className={classes.photosContainer}>
        <Box paddingRight="24px">
          <ManyImagesUpload
            fileType={'.pdf'}
            imageTitle={imageTitle}
            isRequired={false}
            isDisabled={isUploading}
            isLoading={isUploading}
            imageKey={photoOwnerType}
            uploadText={'Upload File'}
            handleFileChange={async (image: any[], files: File[]) => {
              try {
                setUploading(true);

                const formData = new FormData();
                const firstItem = files[0];

                formData.append('CompactionLetterFile', firstItem);
                await createCompactionLetter(jobId, photoOwnerType, formData);

                refetchLetter();
              } catch (error) {
                enqueueSnackbar(
                  error?.response?.data?.Detail ?? 'Error uploading images, please try again.',
                  {
                    variant: 'error'
                  }
                );
              } finally {
                setUploading(false);
              }
            }}
            images={[]}
          />
        </Box>
      </Box>
      <Grid container spacing={1}>
        <>
          {image ? (
            <SMButton
              sx={{
                marginTop: {
                  xs: '1rem'
                },
                marginLeft: {
                  xs: 0,
                  md: '1rem'
                }
              }}
              id="save"
              color="secondary"
              variant="contained"
              startIcon={<Download />}
              onClick={() => {
                handleDownload(image);
              }}
            >
              Letter File
            </SMButton>
          ) : (
            <Typography ml={2} mt={1}>
              No file chosen
            </Typography>
          )}
        </>
      </Grid>
    </>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  photosContainer: {
    display: 'flex',
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    },
    '@media print': {
      display: 'block'
    }
  },
  pics: {
    display: 'block',
    margin: '0 auto',
    maxHeight: 125,
    maxWidth: '100%'
  },
  card: {
    cursor: 'pointer',
    height: 150,
    textAlign: 'center'
  }
}));
